import UserRole from './UserRole'
import Immutable from 'immutable';
import {ReduceStore} from 'flux/utils';
import UserRoleActionTypes from '../actions/UserRoleActionTypes';
import UserRoleDispatcher from '../actions/UserRoleDispatcher';
import GlobalSharedTools from '../../../lib/GlobalSharedTools';

class UserRoleStore extends ReduceStore {
  constructor() {
    super(UserRoleDispatcher);
  }

  getInitialState() {
    return { data: Immutable.OrderedMap(), callbacks: {} };
  }

  reduce(state, action) {
    switch (action.type) {
      case UserRoleActionTypes.ADD_USER_ROLE:
        if (!action.newRole) {
          return state;
        }
        let key = `${action.newRole.id}-${action.newRole.roleName}-${action.newRole.associatName}-${action.newRole.associatObj.id}`   // 12-teacher-classRecord-10, 12-parent-student-234
        state.data = state.data.set(key, new UserRole({
          key,
          id: action.newRole.id,
          roleId: action.newRole.roleId,
          roleName: action.newRole.roleName,
          fullName: action.newRole.fullName,
          associatName: action.newRole.associatName ? action.newRole.associatName : "NA",
          associatObj: action.newRole.associatObj ? action.newRole.associatObj : {id: -1},
        }));

        this.triggerCallbacks('change');
        return state;

      case UserRoleActionTypes.UPDATE_USER_ROLE:
        if (!action.roleKey || !action.newAttrs) {
          return state;
        }
        let oldData = state.data.get(action.roleKey);
        if (!oldData) {
          return state;
        }
        let newData = oldData.toJS();
        Object.keys(action.newAttrs).forEach((key) => newData[key] = action.newAttrs[key])
        state.data = state.data.update(action.roleKey, value => new UserRole({
          key: action.roleKey,
          id: newData.id,
          roleId: newData.roleId,
          roleName: newData.roleName,
          fullName: newData.fullName,
          associatName: newData.associatName ? newData.associatName : "NA",
          associatObj: newData.associatObj ? newData.associatObj : {id: -1},
        }));

        this.triggerCallbacks('change');
        return state;

      case UserRoleActionTypes.DELETE_USER_ROLE:
        if (!action.roleKey) {
          return state;
        }
        state.data = state.data.delete(action.roleKey);

        this.triggerCallbacks('change');
        return state;

      default:
        return state;
    }
  }

  getState() {
    let obj = this._state.data.toJS();
    let state = new Array();
    Object.keys(obj).forEach((key) => {
      state.push(obj[key]);
    })
    return state;
  }

  addChangeListener(callbackFunc) {
    if (GlobalSharedTools.isFunction(callbackFunc)) {
      if ('change' in this._state.callbacks)
        this._state.callbacks['change'].push(callbackFunc);
      else
        this._state.callbacks['change'] = [callbackFunc];
    }
  }

  removeChangeListener(callbackFunc) {
    if (GlobalSharedTools.isFunction(callbackFunc) && ('change' in this._state.callbacks)) {
      let index = this._state.callbacks.change.findIndex((handler) => handler === callbackFunc);
      if (index >= 0)
        this._state.callbacks.change.splice(index, 1);
    }
  }

  triggerCallbacks(sectionName) {
    setTimeout(() => {
      if (this._state.callbacks[sectionName]) {
        this._state.callbacks[sectionName].forEach((fucntionHandler) => fucntionHandler.call());
      }
    }, 0);
  }
}

export default new UserRoleStore();


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/stores/UserRoleStore.js